import {
  CART_ADD_TO_CART_ANIMATION,
  CART_RECEIVE,
  CART_SET_GENERAL_ROW_NOTE,
  CART_SHOW_INFO,
} from '../constants';

export const cart = (
  state = { quantity: 0, orderTotal: 0, showInfo: false },
  action
) => {
  switch (action.type) {
    case CART_RECEIVE:
    case CART_SHOW_INFO:
    case CART_SET_GENERAL_ROW_NOTE:
    case CART_ADD_TO_CART_ANIMATION:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
